import { computed, ref } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiMenuLink } from '@ts-strapi/interfaces'
// hooks
import { useWindowScroll } from '@vueuse/core'
import { useOpenMenuLink } from '@composables/tools/open-menu-link.hook'

interface HeaderMobileOptions {
  primaryButton: () => StrapiMenuLink | null | undefined
}

interface HeaderMobileReturn {
  refIsOpen: Ref<boolean>
  refIsScrolled: ComputedRef<boolean>
  handleOpen: () => void
  handleClose: () => void
  handlePrimaryClick: () => void
}

export const useHeaderMobile = ({ primaryButton }: HeaderMobileOptions): HeaderMobileReturn => {
  const refIsOpen = ref<boolean>(false)

  const { y } = useWindowScroll()
  const refIsScrolled = computed<boolean>(() => y.value > 0)

  const openLink = useOpenMenuLink()

  const handleOpen = (): void => {
    refIsOpen.value = true
  }

  const handleClose = (): void => {
    refIsOpen.value = false
  }

  const handlePrimaryClick = (): void => {
    const link = primaryButton()
    if (!link) return
    openLink(link)
  }

  return {
    refIsOpen,
    refIsScrolled,
    handleOpen,
    handleClose,
    handlePrimaryClick,
  }
}